<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .education-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    gap: utils.in_rem(8px);

    &.skeleton {
      @include mixins.skeleton(
        (
          background-color: colors.get(interfaceTransparentBlack_4),
          border-radius: utils.in_rem(8px),
        )
      );
    }

    .divider {
      width: 100%;
      height: 1px;
      background-color: rgba(28, 28, 28, 0.05);
      flex-shrink: 0;
    }

    .no-data-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .no-data-text {
        @include colors.color(textGrey);

        h3 {
          @include mixins.h3();
          text-align: center;
        }

        span {
          @include mixins.body2();
          text-align: center;
        }
      }
    }
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import NoData from "@sourcewhale/shared/svelte-design-system/components/atoms/NoData.svelte";
  import { candidateEducationStore } from "../../stores";
  import EducationItem from "./EducationItem.svelte";

  const { meta } = candidateEducationStore;

  $: skeleton = $meta.fetching || !$meta.firstFetchDone;
</script>

<div class="education-container" class:skeleton>
  {#if !skeleton}
    {#if $candidateEducationStore.length > 0}
      {#each $candidateEducationStore as education, index (education.startedAt + education.school + education.degree)}
        <EducationItem {education} />
        {#if index < $candidateEducationStore.length - 1}
          <div class="divider"></div>
        {/if}
      {/each}
    {:else}
      <div class="no-data-wrapper">
        <NoData>
          <div slot="icons" class="icons">
            <IconScale
              backgroundColor="interfaceSwGrey_10"
              color="interfaceSwGrey_20"
              class="fa-solid fa-graduation-cap"
              size="xl"
            />
          </div>
          <div slot="text" class="no-data-text">
            <h3>No education available</h3>
            <span>This contact has no education history</span>
          </div>
        </NoData>
      </div>
    {/if}
  {/if}
</div>
